import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';

import { LeadScannerComponent } from './lead-scanner.component';
import { ShowContactsComponent } from './show-contacts/show-contacts.component';
import { InfoUserFormComponent } from './info-user-form/info-user-form.component';
import { TranslateModule } from '@ngx-translate/core';
import { LeadScannerRoutingModule } from './lead-scanner-routing.module';

@NgModule({
  declarations: [LeadScannerComponent, ShowContactsComponent, InfoUserFormComponent],
  imports: [
    SharedModule,
    TranslateModule,
    LeadScannerRoutingModule
  ]
})
export class LeadScannerModule {
}
